import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "../../components";
import { SessionService, history } from "../../services";
// import {
//   ResumoContasReceber,
//   ResumoContasPagar,
//   ResumoVendasHoraMes,
// } from "./components";
import { PermisoesHelper } from "../../helpers";
import "./main.view.scss";
import store from "../../config/store";

const Main = () => {
  const sessionService = new SessionService();
  const permisoesHelper = new PermisoesHelper();
  const [usuario, setUsuario] = useState("");
  // const [permissaoDashboard, setPermissaoDashboard] = useState(false);
  const dadosEmpresa = sessionService.getEmpresa();

  useEffect(() => {
    setUsuario(sessionService.getUsuario());
    // getPermissaoDashboard();
  }, []);

  const menu = [
    // {
    //   title: "Pessoas",
    //   path: "/integracao/pessoas",
    //   icon: "ph-fill ph-users",
    //   permission: "pessoas-visualizar",
    // },
    // {
    //   title: "Produtos",
    //   path: "/estoque/produtos",
    //   icon: "ph-fill ph-package",
    //   permission: "produtos-visualizar",
    // },
    // {
    //   title: "Orçamentos",
    //   path: "/faturamento/orcamentos",
    //   icon: "ph-fill ph-receipt",
    //   permission: "orcamentos-visualizar",
    // },
    // {
    //   title: "Pedidos",
    //   path: "/faturamento/pedidos",
    //   icon: "ph-fill ph-file-text",
    //   permission: "pedidos-visualizar",
    // },
    // {
    //   title: "NF Saída",
    //   path: "/faturamento/nf-saida",
    //   icon: "ph-fill ph-scroll",
    //   permission: "nf-saida-visualizar",
    // },
    {
      title: "Orçamento de Serviço",
      path: "/faturamento/orcamento-servicos",
      icon: "ph-fill ph-note",
      permission: dadosEmpresa?.moduloServico,
    },
    {
      title: "Ordem de Serviços",
      path: "/faturamento/ordem-servicos",
      icon: "ph-fill ph-notepad",
      permission: dadosEmpresa?.moduloServico,
    },
    // {
    //   title: "Caixa",
    //   path: "/financeiro/caixa",
    //   icon: "ph-fill ph-desktop",
    //   permission: "caixa-visualizar",
    // },
  ];

  function getMenusComPermissao(menu) {
    return menu.filter(
      (menuItem) =>
        permisoesHelper.temPermisao(menuItem.permission) ||
        menuItem.permission === true,
    );
  }

  // function getPermissaoDashboard() {
  //   const temPermissao = permisoesHelper.temPermisao("dashboard");
  //   setPermissaoDashboard(temPermissao);
  // }

  const images = {
    logo: "https://public.siafevolution.com.br/icon-lite.svg",
  };

  return (
    <div className="main-layout-container">
      <Typography variant="subtitle1" className="welcome-text">
        Olá, {usuario.nome}! Veja como estão as coisas.
      </Typography>
      <Grid container spacing={3} className="menu-grid">
        {getMenusComPermissao(menu).map((item, index, menuPermissao) => (
          <Grid
            item
            xs={12 / (menuPermissao?.length || 1)}
            key={index}
            className="atalhos-main-view"
          >
            <Button
              className={"rounded-4 mainAtalhos"}
              fullWidth
              startIcon={
                <i className={`${item.icon} mainAtalhos-icon-main`}></i>
              }
              onClick={() => {
                history.push(item.path);
              }}
            >
              <Typography
                className={`mainAtalhos-text-main ${
                  item.disabled ? "mainAtalhosDisabled-text" : ""
                }`}
              >
                {item.title}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>

      <Grid container className="dashboard-placeholder">
        <img
          src={images.logo}
          className="img-logo-dashboard"
          alt="Logo Siaf Lite"
        />
      </Grid>

      <footer className="versao">Versão Siaf Lite - {store?.version}</footer>
    </div>
  );
};

export default Main;
